import { Component, DestroyRef, EventEmitter, inject, Input, Output } from '@angular/core';
import { VehicleTypeModalComponent } from '@shared/components/vehicle-type-modal/vehicle-type-modal.component';
import {
  EQUIPMENT_INFO_DELETED_MSG,
  MSG_DELETE_EQUIPMENT,
} from '@shared/constant/shared.constant';
import { CommonMenuService } from '@shared/services/common-util.service';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { ToastService } from '@shared/services/toast.service';
import { ConfirmationService } from 'primeng/api';
import { SuperAdminService } from '@core/services/super-admin.service';
import { autoUnsubWith } from '@shared/services/utility.abstract';

@Component({
  selector: 'app-vehicle-information',
  templateUrl: './vehicle-information.component.html',
  styleUrls: [
    '../../modules/driver/components/driver-profile/driver-profile.component.scss',
    './vehicle-information.component.scss',
  ],
})
export class VehicleInformationComponent {
  readonly destroyRef = inject(DestroyRef);
  @Output() emitForvehicleListApi = new EventEmitter();
  @Input() allGoVehicle: any[] = [];
  @Input() addButton = false;
  @Input() items: any[] = [];
  @Input() spotTypeMsg: string = '';
  @Input() activeItem: any;
  @Input() userId: string | null = null;

  constructor(
    private readonly dialogControlService: DialogControlService,
    private readonly commonMenuService: CommonMenuService,
    private readonly toastService: ToastService,
    private readonly superAdminService: SuperAdminService,
    private readonly confirmationService: ConfirmationService
  ) {}

  openBookingDetail(data) {
    this.dialogControlService.openDialog(VehicleTypeModalComponent, {
      styleClass: 'truck-modal',
      data: {
        truckType: null,
        comingFrom: 'DriverProfileSection',
        driverId: this.userId,
        data: data,
      },
    });
    this.dialogControlService.onClose().subscribe(() => {
      this.emitForvehicleListApi.emit(this.userId);
    });
  }

  showData(product: any, event) {
    const actionMap = {
      edit: () => this.onRowEditInit(product),
      delete: () => this.onRowDelete(event, product),
    };

    const config = [
      {
        label: '',
        icon: '',
      },
      {
        label: 'Edit',
        icon: 'common-icon custom-editicon',
        command: actionMap.edit,
      },
      {
        label: 'Delete',
        icon: 'common-icon custom-delete',
        command: actionMap.delete,
      },
    ];

    this.items = this.commonMenuService.commonShowData(config);
  }

  onRowEditInit(_product) {
    this.openBookingDetail(_product);
  }

  onRowDelete(event, product) {
    event.preventDefault();
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: MSG_DELETE_EQUIPMENT,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        const request = {
          id: product.id,
          driverId: this.userId,
        };
        this.superAdminService
          .deleteDriverVehicleByVehicleId(request)
          .pipe(autoUnsubWith(this.destroyRef))
          .subscribe({
            next: (_response: any) => {
              
              this.emitForvehicleListApi.emit(this.userId);
              this.toastService.showToastMessage(
                'success',
                'Success',
                EQUIPMENT_INFO_DELETED_MSG
              );
            },
            error: (error) => {
              this.toastService.showToastMessage(
                'error',
                'Error',
                error.error.message
              );
            },
          });
      },
    });
  }
}
